module.exports = __webpack_public_path__ + "img/59404f1.jpg";